// src/components/VisitorTracker.tsx
import { useEffect } from 'react';
import { visitorService } from '../services/visitorService';

export const VisitorTracker: React.FC = () => {
    useEffect(() => {
        // Отслеживаем посещение при загрузке приложения
        visitorService.trackVisit().catch(console.error);
    }, []);

    return null; // Ничего не рендерим
};